export default {
  MEMBER_GET_PERMISSION_FETCHED: 'MEMBER_GET_PERMISSION_FETCHED',
  MEMBER_GET_PERMISSION_LOAD: 'MEMBER_GET_PERMISSION_LOAD',
  MEMBER_GET_PERMISSION_TEMPLATES_FETCHED: 'MEMBER_GET_PERMISSION_TEMPLATES_FETCHED',
  MEMBER_GET_PERMISSION_TEMPLATES_LOAD: 'MEMBER_GET_PERMISSION_TEMPLATES_LOAD',
  MEMBER_GET_PERMISSION_DETAIL: 'MEMBER_GET_PERMISSION_DETAIL',
  MEMBER_GET_PERMISSION_BUTTON_LOAD: 'MEMBER_GET_PERMISSION_BUTTON_LOAD',
};
